
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission, FieldDynamicUrlLinkButtonProjectContext } from '@core/objects/form';

@Component({
    selector: 'form-field-view-dynamic-url-link-button-v1',
    templateUrl: './view-dynamic-url-link-button-v1.component.html'
})
export class ViewDynamicUrlLinkButtonV1FieldComponent implements OnInit {
    private readonly PROJECT_PATTERN = '{PROJECTID}';
    private readonly FORM_PATTERN = '{FORMID}';

    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Input() dynamicLinKButtoncontext: FieldDynamicUrlLinkButtonProjectContext;
    
    public link: string = ''
    ngOnInit(): void {

        // Set the link value only if the provided field value is not an empty string and context is set
        if (this.dynamicLinKButtoncontext && this.fieldSubmission.field?.options?.url && this.dynamicLinKButtoncontext.project && this.dynamicLinKButtoncontext.form) {
            this.link = this.fieldSubmission.field.options.url
                .replace(
                    this.PROJECT_PATTERN, this.dynamicLinKButtoncontext.project)
                .replace(
                    this.FORM_PATTERN, this.dynamicLinKButtoncontext.form)
        }
    }

    goToUrl() {

        window.open(this.link, '_blank');
    }

}
